/* eslint-disable @typescript-eslint/naming-convention */
import { FilterKey } from '@core/Entities/Search/QueryParams.entity';

const getFilterFromArray = (id: FilterKey, filters: any[]) => {
  return filters.find(fltr => fltr.id === id);
};

export const buildPlpTargeting = (filtersList: any) => ({
  hc_make: getFilterFromArray('make', filtersList)?.value?.[0],
  hc_model: getFilterFromArray('model', filtersList)?.value?.[0],
  hc_category: getFilterFromArray('body-type', filtersList)?.value?.[0],
  hc_fuel_type: getFilterFromArray('fuel-type', filtersList)?.value?.[0],
  hc_section: 'PLP',
});
